export const contentTerms= {
  "what-is-flowcess": {
    title: "Flowcess",
    content: `
      <p class="content">Flowcess is one of the anydone’s project folder where you can build AI agents in the most advanced AI Studio. You can view and create all the AI agents here, ensuring they remain organized and accessible from one place.</p>
      <p class="content">From Flowcess you can create, run, organize, and manage all of your AI agents seamlessly. Also, you can oversee the status of your automation process, whether they are active or inactive. </p>
      <p>All in all, the main essence of Flowcess folder is to simplify AI agent management with its structured and user-friendly environment.</p>
      <image-component src="https://edge-a.anydone.com/treeleaf/ed0ab217-9e44-449a-bf5a-35f551889718.png" alt="Flowcess-anydone-ai-agent-adoption-platform"></image-component>

      <p>When you create a new project in anydone, the Flowcess folder will be created in the project by default, and the default Flowcess folder name is <strong>'Automation'</strong>. However, you <span class="text-blue">create a new Flowcess folder</span> in your existing one also. </p>

      <image-component src="https://edge-a.anydone.com/treeleaf/0927d85c-7a0e-40de-aece-afdb585ef7fc.png" alt="Flowcess-anydone-ai-agent-adoption-platform"></image-component>

      <p>When you hover over the Flowcess folder and click the three horizontal dots, you can view the following options to manage it;</p>
      <ul>
      <li><strong>Add to Favorite:</strong> Selecting this option will move the Flowcess folder to the top of all created folders in the project.</li>
      <li><strong>Add to Bookmark:</strong> Bookmark the Flowcess folder for easy access from anywhere on the anydone dashboard.</li>
      <li><strong>Edit:</strong> Update the folder name and description as needed.</li>
      <li><strong>Archive:</strong> Archive the folder. Once archived, AI Agents created in the Flowcess folder will no longer be available, and any triggered or running AI Agents will stop working.</li>
      <li><strong>Process:</strong> help.anydone.com/ai-agents-guide/what-is-process </li>
      </ul>
      <p>In anydone, a Process is where you define how data is structured, transformed, and connected to your AI Agents. It serves as one of the foundational building blocks of AI agents. </p>
      <p>Once a Process is created, it can be used within anydone AI Studio, where you can use further AI models to build autonomous and tailored AI agents that perfectly suits needs.</p>
      <p>A Process defines how the AI agent receives input, interprets it, and gives contextual, accurate, and reliable output, enabling your agents to perform tasks independently and at scale.</p>
      `,
  },
  "what-is-process": {
    title: "How Process Works?",
    content: `
      <p>Understanding how a Process functions is one of the key functions to build autonomous AI agents in anydone. It defines the flow of data from input to output, ensuring your agent operates with clarity and precision. This structured flow ensures your AI agent understands the input and delivers accurate, and usable outputs.</p>
      <h3>Model Type Configuration</h3>
      <p>First, you need to choose the model type to power your Process. You can choose between default <strong>Anydone Model</strong>, or use third-party models from providers like <span class="text-blue">OpenAI</span>, <span class="text-blue">Google</span>, <span class="text-blue">Amazon AWS</span>, and others.</p>

      <h3><i class="fa-solid fa-arrow-right-long"></i> Input Mapping</h3>
      <p>Here, you need to define the <strong>Input Type</strong>. This determines what kind of input the Process will receive—whether it is static (predefined and fixed) or dynamic (provided by the user or system in real time).</p>
      <p>After selecting the <strong>input type</strong>, you need to define the Data Type. This means specifying what kind of data the Process will accept as input—such as text, numbers, selections,etc. Clearly defining the input ensures that your Process can correctly receive and work with the data provided by the user or the system during execution.</p>

      <h3><i class="fa-solid fa-arrow-right-long"></i> Output Mapping</h3>
      <p>After defining the input, the next step in creating a Process is configuring the Output. Here, you need to select the <strong>Output Mapping Type</strong>, which determines how the Process should structure and present the output.</p>
      <p>To make this easier, we provide a predefined Output Sample in JSON format for each Process. You can simply select the output sample and then automatically it will  assign it to the <strong>Map To</strong> section. This helps you define the generated response as accurate, organized, and ready to be used in the further steps for your AI Agent.</p>

      <h3>Output Sample</h3>
      <p>To make things easier, every anydone Process includes a predefined output sample in JSON format. This sample acts as a ready-to-use short JASON code, allowing you to quickly map your output fields without having to manually define the structure. You simply select the output sample that you want for your Process and accordingly.</p>

      <p>Here are the complete overview of anydone’s Process type:</p>
        <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Speech to Text</th>
              <th>Text to Speech</th>
              <th>OCR</th>
              <th>Grammar Check</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Information Retrieval</td>
              <td>Image Generation</td>
              <td>Face Detection</td>
              <td>Translation</td>
            </tr>
            <tr>
              <td>Object Detection</td>
              <td>Code Generation</td>
              <td>Text Generation</td>
              <td>Text Summarize</td>
            </tr>
            <tr>
              <td>Image Comparison</td>
              <td>Code Review</td>
              <td>Face Recognition</td>
              <td>Lookup & Form Update</td>
            </tr>
            <tr>
              <td>Image Understanding</td>
              <td>Github Integration</td>
              <td>API</td>
              <td class="highlighted-cell">WebAssembly</td>
            </tr>
          </tbody>
        </table>
        <p class="note">
          Notably, you can select any process type from above to explore and
          learn how
        </p>
      </div>
    `,
  },
  "what-is-ai-agent": {
    title: "AI Agent",
    content: `
      <p>AI agents are designed to autonomously handle various business processes of any scale. With anydone’s rich AI models and tools, you can build AI agents with zero code. Our aim is to enable your business to scale and grow using the transformative power of AI.</p>
      <p>Talking about our AI Agents, it goes beyond natural language processing and is designed to operate tasks autonomously. They can make decisions, solve problems, interact with internal and external environments, and execute actions with minimal human intervention.</p>
      <p>With anydone, you can not only build AI agents using its own comprehensive set of models but also <span class="text-blue">integrate models from other providers </span> and create AI agents that are perfectly suited to automate your business operations.</p>
      <p>Once you <span class="text-blue">build your AI agents</span>, you can run it across omnichannels. This flexibility ensures a consistent and efficient automation process across various touchpoints.</p>
      <p>Overview of anydone AI Agent section:</p>

      <image-component src="https://edge-a.anydone.com/treeleaf/d524d41b-0a75-40ab-8521-f513d66c0a97.png" alt="Build-ai-agent-with-no-code"></image-component>

      <p>You can view, search AI Agents respective with their name from here.</p>
      <h3>Running Instance</h3>
      <p>Indicates that a specific execution of an automation process is currently in progress.</p>

      <h3>Trigger</h3>
      <p>Select your preferred channel to run your AI Agents.</p>

      <p>Upon hovering over the AI Agent, you will see three horizontal dots, click on it then you will see the following options;</p>

      <image-component src="https://edge-a.anydone.com/treeleaf/7d0fbf4e-e2e9-4df2-97f1-928371cea2e3.png" alt="Flowcess-anydone-ai-agent-adoption-platform"></image-component>
      
      <ol type="a">
      <li><strong class="underline-text">Try Now:</strong> <br/> Once you’ve built your AI Agent, you can test it immediately to view its results in real time.</li>
      <li><strong class="underline-text">Edit:</strong> <br/>Update your AI Agent name and description.</li>
      <li><strong class="underline-text">Delete:</strong> <br/>Remove the AI Agent permanently.</li>
      <li><strong class="underline-text">View All Instances:</strong> <br/>When clicked, you can view instances of your automation process like;

      <image-component src="https://edge-a.anydone.com/treeleaf/4ce495d6-c99c-4a4e-b38a-afb69654a3ca.png" alt="business-automation-platform-anydone"></image-component>
      

      <ol class="sub-list">
        <li><strong>Instance Name:</strong> View all instances where your AI Agent has been triggered, such as WhatsApp, Messenger, <span class="text-blue">Chat Plugin</span>, etc under their respective names in the <span class="text-blue">app directory</span>.</li>
        <li><strong>Session:</strong> View all the sessions for each of your instances.</li>
        <li><strong>Status:</strong> View and monitor the status of your instances, such as whether it is running, completed, stopped, or so on.</li>
        <li><strong>Stop:</strong> You can stop any running instance you want, it will pause your automation process, and you can resume it whenever you want.</li>
        <li><strong>View Configuration:</strong>  You can view the events of your AI Agent where it is running, also you can view its inputs, and other configuration details. For eg; If your AI Agent is running in a Chat Plugin, you can access its url, embedded code, and inputs. Notably, the details available here depend on which channel your AI Agent is running in.</li>
        <li>You can view all your instances based on their status, such as running, stopped, completed, or error. To filter the instances, click the dropdown icon next to ,strong>'All'</strong> and select your preferred option.</li>
      </ol>

      <image-component src="https://edge-a.anydone.com/treeleaf/4ce495d6-c99c-4a4e-b38a-afb69654a3ca.png" alt="best-agentic-process-automation"></image-component>

      </li>
      <li><strong class="underline-text">View Log:</strong> <br/> Get detailed information on every step, action, and event of your AI Agent. However, make sure to <strong>add a Log block</strong> in each of your blocks in AI Studio.


      <image-component src="https://edge-a.anydone.com/treeleaf/3224ee02-b8c4-4299-a4ae-b212f58459fc.png" alt="best-automation-platform"></image-component>

      <ol type="i" class="sub-list">
      <li>First you can view details like <strong><Logged At</strong> that displays an exact time when someone interacts with your AI Agents. <strong>Block</strong> includes the list of blocks you have used to build an AI Agent in AI Studio along with their name. <strong>Message</strong> signifies whether the specific block has executed and completed the tasks or not.</li>
      <li><strong>Instance:</strong> Click the dropdown icon here and select the instance you want to view logs for. For eg; if your AI Agent is running on multiple channels, then from here you can select your preferred channel and view its instances simultaneously .</li>
      <li><strong>Sessions:</strong> Click the dropdown icon here and select instance session ID to view its log.</li>
      <li><strong>Log Level:</strong> Click the dropdown icon here, filter by log type such as Error or Message, and view it seamlessly.</li>
      </ol>
      </li>
      <li><strong class="underline-text">View Output:</strong> <br/> Instantly view the outputs of your AI Agent. You can Filter the output with options such as Instances, Session, and Log Level and view the output immediately.</li>
      <li><strong class="underline-text">View User Information:</strong> <br/> Upon click the View user information you can see options like this;

      <image-component src="https://edge-a.anydone.com/treeleaf/12742b11-87da-4a32-822e-b605049b096b.png" alt="best-ai-agent-platform-anydone"></image-component>

      <ol class="no-listing">
      <li><strong></strong>If the user has entered their <strong>name</strong> and <strong>email</strong> while interacting with your AI Agent, you can view them here.</li>
      <li>If your AI Agent is running on multiple channels, you can see which channel the user used to interact with in the <strong>'Source'</strong>.</li>
      <li><strong>'Devices'</strong> shows the type of device and browser the user used during their interaction. </li>
      <li>The <strong>'Timestamp'</strong> displays the exact time the event occurred.</li>
      <li>You can click on any listed user information to see more details like their IP address and more. When you click, you will see the following:</li>
      </ol>
      </li>

      <image-component src="https://edge-a.anydone.com/treeleaf/370485be-102a-461e-a02c-b18c39283982.png" alt="best-automation-platform-anydone"></image-component>
      
      </ol>
    `,
  },
  "what-is-firewall": {
    title: "Create New Flow",
    description: "This is the create flow content.",
  },
  "what-is-ai-studio": {
    title: "AI Studio",
    content: `
    <p>Anydone’s advanced AI Studio is designed for building AI Agents of any kind. With anydone’s AI studio you can get advanced AI models and tools, for building powerful AI Agents with no code.</p>
    <p>To make things simple, anydone’s AI Studio is an infinite canvas where users can add and connect multiple AI building blocks, map inputs, define outputs and get started with running their business with AI Agents.</p>
    <p>The studio also offers the flexibility to connect and configure limitless automation blocks, allowing you to build intelligent agents tailored to specific needs. Anydone’s AI Studio View</p>

    <image-component src="https://edge-a.anydone.com/treeleaf/36a72a48-950e-4299-9f48-d10a1dd155b0.png" alt="Anydone-ai-studio-ai-agents"></image-component>

    <h2 class="headingTwo">Block Components</h2>
    <ol type="a" class="two-layer">
    <li>Controls</li>
    <li>AI Models</li>
    <li>Knowledge Engine</li>
    <li>Intents</li>
    <li>Data Store</li>
    <li>API</li>
    <li>Tickets</li>
    <li>Function</li>
    </ol>

    <h2 class="headingTwo">Controls</h2>
    <p>These are operations and actions that govern the flow of tasks within an automation workflow.</p>

    <image-component src="https://edge-a.anydone.com/treeleaf/ecf581b7-f706-42d8-bbcd-64f64b929a77.png" alt="powerful-ai-studio-ai-agent-platform"></image-component>

    <h3 class="underline-text">Task</h3>
    <p>Represents a single step or unit of work in a workflow.</p>
    <ol class="two-layer no-listing">
    <li><strong>Data Request</strong></li>
    <li><strong>Find in Internet</strong></li>
    <li><strong>Authentication</strong></li>
    <li><strong>Web Scraping</strong></li>
    </ol>

    <h3 class="underline-text">Condition</h3>
    <p>Logical operations to evaluate, compare, count, check, conditions and control the flow of a workflow based on specific criteria.</p>
    <ol class="two-layer no-listing">
    <li><strong>Compare</strong></li>
    <li><strong>Contains</strong></li>
    <li><strong>Check</strong></li>
    <li><strong>Counts</strong></li>
    <li><strong>Condition Evaluation</strong></li>
    </ol>

    <h3 class="underline-text">Output</h3>
    <p>Actions that produce or send outputs from the automation platform.</p>
    <ol class="two-layer no-listing">
    <li><strong>Log</strong></li>
    <li><strong>Send Reply</strong></li>
    <li><strong>Forward</strong></li>
    <li><strong>Send Mail</strong></li>
    <li><strong>WhatsApp Template</strong></li>
    </ol>

    <h3 class="underline-text">Input</h3>
    <p>Captures user input or external data, which can be text, numbers, files, or other formats.</p>

    <h3 class="underline-text">Data</h3>
    <p>Manage data storage, templates, and variables.</p>
    <ol class="three-layer no-listing">
    <li><strong>Template</strong> </li>
    <li><strong>File</strong> </li>
    <li><strong>Variables</strong></li>
    </ol>

    <h3 class="underline-text">Chat Plugin</h3>
    <p>Operations specific to anydone Chat Plugin.</p>
    <ol class="three-layer no-listing">
    <li><strong>Get URL</strong></li>
    <li><strong>Create Thread</strong></li>
    <li><strong>Create Message</strong></li>
    </ol>

    <h2 class="headingTwo">AI Models</h2>
    <p>Under the AI Models section, all models created in Anydone Process will be displayed. From here, you can use the created AI models and begin building your AI agents.</p>

    <image-component src="https://edge-a.anydone.com/treeleaf/e65ec081-23bb-4488-880c-aa2704c0bbc8.png" alt="ai-models-anydone-agentic-ai-platform"></image-component>

    <p>Additionally, here we also offer built-in AI models . These pre-trained models are ready to use and can be seamlessly integrated into your workflows. Simply select the built-in model that best suits your needs and use it to build your desired AI agent effortlessly.</p>

    <p>Another model here you can get is Anydone Intelligence, a powerful AI model designed to automate a wide variety of tasks. To name a few, from translation and text generation to speech-to-text, text-to-speech, and even image generation, and more this AI model is trained to handle it all autonomously.</p>

    <p>There’s no need for any configurations or setups, just select the model, build you AI Agent and let Anydone Intelligence do the rest.</p>

    <p>Here are the built in AI Models that we offer;</p>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Code Review</th>
              <th>Text Generation</th>
              <th>Object Detection</th>
              <th>OCR Image</th>
              <th>Speech to Text</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Code Generation</td>
              <td>Image Understanding</td>
              <td>Face Detection</td>
              <td>Translation</td>
              <td rowspan="2">NP Passport Extraction</td>
            </tr>
            <tr>
            <td>Image Generation</td>
            <td>Image Comparsion</td>
              <td>Face Compare</td>
              <td>Text to Speech</td>
            </tr>
          </tbody>
        </table>
      </div>
    <br/>
    <h2 class="headingTwo">Knowledge Engine</h2>
    <p class="underline-text text-blue">You can learn more about Knowledge Engine here. </p>
    <p>If you haven’t created a Knowledge Engine yet, don’t worry—you can get started with our Default Knowledge Engine and start building your AI Agent right away.</p>

    
    <image-component src="https://edge-a.anydone.com/treeleaf/414b02dc-a80d-46bf-a245-0b6577b61834.png" alt="ai-automated-reply-anydone-ai-agent"></image-component>
    <p>Other than that, from anydone’s AI Studio also you can <span class="text-blue">create a new Knowledge Engine</span> and start building your AI Agent. </p>

    <image-component src="https://edge-a.anydone.com/treeleaf/90af0f27-b312-47d1-8b02-a2ae66e8aab5.gif" alt="anydone-reply-automation-ai-agents"></image-component>

    <p>Additionally, you can also manage, organize, and try out the model before starting to build an AI Agent using Knowledge Engine.</p>

    <image-component src="https://edge-a.anydone.com/treeleaf/567724d8-5660-4707-bc0f-327e1663e7ca.gif" alt="anydone-ai-agent-reply-automation"></image-component>

    <p>Once you select your preferred Knowledge Engine, you can continue to configure its additional settings. </p>

    <image-component src="https://edge-a.anydone.com/treeleaf/7e161637-b5f7-4e0e-89ea-47388f339bb4.png" alt="automating-query-anydone-best-ai-agent-platform"></image-component>


    <ol class="no-listing">
    <li><strong>Enable Follow-Up: </strong> Allows to generate responses based on the history of previous interactions.</li>
    <li><strong>Allow Response Variation:</strong> Allow to provide diverse responses to the same query each time it is asked. </li>
    <li><strong>Temperature: </strong> Set the randomness or creativity of the responses, use a low temperature when precision and consistency are required, use a high temperature when you want more engaging, varied, or exploratory responses.</li>
    </ol>
    <p>Please note that if you choose not to use the Default Knowledge Engine, you’ll need to create a model from anydone Automation Tool >> AI, please refer to our comprehensive <span class="text-blue">tutorial of Knowledge Engine</span> here.</p>

    <h2 class="headingTwo">Intent, API, Tickets</h2>
    <p>Anydone's AI Studio components, such as Intents, API, and Tickets, need to be created in the <span class="text-blue">Anydone Process section</span>. Once you have created them, you can select your specific models and start building AI Agents.</p>
    <ol class="no-listing">
    <li><strong class="text-blue italic-text">How to create Intents and build AI Agents with it ?</strong></li>
    <li><strong class="text-blue italic-text">How to create AI Agents using API ?</strong></li>
    <li><strong class="text-blue italic-text">How to automate Ticket workflow ?</strong></li>
    </ol>

    <p><strong class="underline-text">Data Store: </strong><br/> A Data Store is a centralized repository used to save, manage, and retrieve data. It allows you to store information collected from forms or other sources.</p>
    <p><strong class="underline-text">Save Data: </strong><br/> You can use Save Data to build an AI Agent that captures and stores specific data from a form by selecting the relevant form fields.</p>
    <p><strong class="underline-text">Form Find All: </strong> </br> You can use Form Find All to build an AI Agent that allows you to search and retrieve specific data entries from the form responses data. </p>

    <h2 class="headingTwo underline-text">WebAssembly</h2>
    <p>You can upload and create a custom WebAssembly file from <span class="text-blue">anydone Process</span>. Once created, it will be displayed in the list below, from here you can select it and begin building your AI Agent.</p>
    <p>Alternatively, we provide a wide range of pre-built WebAssembly modules that you can choose from to quickly get started. </p>

    <image-component src="https://edge-a.anydone.com/treeleaf/9931b0f2-36ad-4a1e-a02b-de9e1f0b1399.png" alt="Webassembly-ai-agent-process-anydone"></image-component>

    <p>Below, we explain each built in models in detail:</p>
    <ol class="no-listing">

    <li><strong class="underline-text">For Cryptographic Operations: </strong> 
    <ol class="two-layer no-listing">
    <li><strong>Sha512 compare: </strong> Compare two SHA-512 hash values to determine if they are identical. </li>
    <li><strong>Sha 512:</strong> Generates a SHA-512 hash from input data.</li>
    <li><strong>Sha256 compare: </strong> Similar to "Sha512 compare," but uses the SHA-256 hashing algorithm.</li>
    <li><strong>Sha 256:</strong> Generates a SHA-256 hash from input data.</li>
    </ol>
    </li>

    <li><strong class="underline-text">Date and Time Operation:</strong> 
    <ol class="two-layer no-listing">
    <li><strong>Subtract date: </strong> Calculates the difference between two dates.</li>
    <li><strong>Parse datetime: </strong> Converts a string representation of a date and time.</li>
    </ol>
    </li>

    <li><strong class="underline-text">For Validation and Randomization:</strong> 
    <ol class="two-layer no-listing">
    <li><strong>Is url valid:  </strong> Checks whether a given string is a valid URL.</li>
    <li><strong>Random string: </strong> Generates a random alphanumeric string of a specified length.</li>
    <li><strong>Random number: </strong> Generates a random number within a specified range.</li>
    <li><strong>Uuid v4: </strong> Generates a Universally Unique Identifier (UUID) using version 4.</li>
    </ol>
    </li>

    <li><strong class="underline-text">For Text Manipulation Operations:</strong> 
    <ol class="three-layer no-listing">
    <li><strong>Text remove:</strong> Removes specific substrings from a given text.</li>
    <li><strong>Text replace:</strong> Replaces occurrences of a substring within a text with another substring.</li>
    <li><strong>Lowercase text:</strong> Converts all characters in a string to lowercase.</li>
    <li><strong>Get JSON object:</strong> Parses and converts strings into a structured JSON object.</li>
    <li><strong>Count word:</strong> Counts the number of words in a given text.</li>
    <li><strong>Uppercase text:</strong> Converts all characters in a string to uppercase.</li>
    <li><strong>Text split:</strong> Splits a string into an array of substrings based on a delimiter.</li>
    </ol>
    </li>

    <li><strong class="underline-text">For Mathematical Operations</strong> 
    <ol class="two-layer no-listing">
    <li><strong>Division math:</strong> Performs division between two numbers.</li>
    <li><strong>Diff math:</strong> Calculates the difference(subtraction) between two numbers.</li>
    <li><strong>Product math:</strong> Multiplies two or more numbers together.</li>
    <li><strong>Sum math:</strong> Adds two or more numbers together</li>
    </ol>
    </li>
    </ol>

    <h2 class="headingTwo underline-text">AI Models</h2>
    <p>Under <strong>AI Models</strong>, you can <span class="text-blue">view all the Process</span> you have created. If you haven't created any, you'll have access to a list of built-in AI models instead. Below is a list of available models you can choose from.</p>

    <image-component src="https://edge-a.anydone.com/treeleaf/82931663-e163-49cc-86d5-714bf6705419.png" alt="built-in-ai-models-anydone-ai-agent-platform"></image-component>

    <ul class="three-layer">
    <li>Code Generation</li>
    <li>Code Review</li>
    <li>Speech to Text</li>
    <li>Image Generation</li>
    <li>Text Generation</li>
    <li>Image Understanding</li>
    <li>Image Comparison</li>
    <li>Object Detection</li>
    <li>Face Detection</li>
    </ul>
    `,
  },
  "what-is-ai-coworker": {
    title: "Create New Flow",
    description: "This is the create flow content.",
  },
};
